import { render, staticRenderFns } from "./DingTalkPcSchoolMenu.vue?vue&type=template&id=59a0e151&scoped=true"
import script from "./DingTalkPcSchoolMenu.vue?vue&type=script&lang=js"
export * from "./DingTalkPcSchoolMenu.vue?vue&type=script&lang=js"
import style0 from "./DingTalkPcSchoolMenu.vue?vue&type=style&index=0&id=59a0e151&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a0e151",
  null
  
)

export default component.exports